import React from "react";
import { Link } from "react-router-dom";

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 py-4 shadow-sm">
        <div className="max-w-4xl mx-auto px-8">
          <Link
            to="/login"
            className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-indigo-500 to-purple-600 no-underline"
          >
            就活ダッシュボード
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">利用規約</h1>

        <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 space-y-6 text-gray-700 leading-relaxed">
          <section>
            <p className="text-sm text-gray-500 mb-4">
              最終更新日: {new Date().toLocaleDateString("ja-JP")}
            </p>
            <p>
              この利用規約（以下「本規約」といいます）は、就活ダッシュボード（以下「本サービス」といいます）の利用条件を定めるものです。本サービスをご利用いただく際には、本規約の全文をお読みいただいたうえで、同意いただく必要があります。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第1条（適用）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                本規約は、本サービスの提供条件及び本サービスの利用に関する当方と利用者との間の権利義務関係を定めることを目的とし、利用者と当方との間の本サービスの利用に関わる一切の関係に適用されます。
              </li>
              <li>
                利用者は、本サービスを利用することによって、本規約に同意したものとみなされます。
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第2条（利用登録）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                本サービスの利用を希望する方は、本規約に同意の上、Googleアカウントを用いて利用登録を行うものとします。
              </li>
              <li>
                利用登録の申請があった場合、当方は審査を行い、当方が適当と判断した場合にのみ、利用登録を承認します。
              </li>
              <li>
                当方は、以下のいずれかの事由に該当する場合、利用登録の申請を承認しないことがあります。
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>利用登録の申請に虚偽の事項を届け出た場合</li>
                  <li>本規約に違反したことがある者からの申請である場合</li>
                  <li>その他、当方が利用登録を相当でないと判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第3条（アカウント情報の管理）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                利用者は、自己の責任において、本サービスに関するアカウント情報を適切に管理するものとします。
              </li>
              <li>
                利用者は、いかなる場合にも、アカウント情報を第三者に譲渡または貸与することはできません。
              </li>
              <li>
                アカウント情報が不正に使用されたことによって利用者に生じた損害について、当方は一切の責任を負いません。
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第4条（禁止事項）
            </h2>
            <p className="mb-2">
              利用者は、本サービスの利用にあたり、以下の行為をしてはなりません。
            </p>
            <ol className="list-decimal list-inside space-y-2">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>
                当方のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
              </li>
              <li>当方のサービスの運営を妨害するおそれのある行為</li>
              <li>他の利用者に関する個人情報等を収集または蓄積する行為</li>
              <li>他の利用者に成りすます行為</li>
              <li>
                当方のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
              </li>
              <li>その他、当方が不適切と判断する行為</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第5条（本サービスの提供の停止等）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                当方は、以下のいずれかの事由があると判断した場合、利用者に事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>
                    本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
                  </li>
                  <li>
                    地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
                  </li>
                  <li>コンピュータまたは通信回線等が事故により停止した場合</li>
                  <li>その他、当方が本サービスの提供が困難と判断した場合</li>
                </ul>
              </li>
              <li>
                当方は、本サービスの提供の停止または中断により、利用者または第三者が被ったいかなる不利益または損害について、理由を問わず一切の責任を負わないものとします。
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第6条（利用制限および登録抹消）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                当方は、以下のいずれかに該当する場合には、事前の通知なく、利用者に対して、本サービスの全部もしくは一部の利用を制限し、または利用者としての登録を抹消することができるものとします。
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>本規約のいずれかの条項に違反した場合</li>
                  <li>登録事項に虚偽の事実があることが判明した場合</li>
                  <li>
                    その他、当方が本サービスの利用を適当でないと判断した場合
                  </li>
                </ul>
              </li>
              <li>
                当方は、本条に基づき当方が行った行為により利用者に生じた損害について、一切の責任を負いません。
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第7条（免責事項）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                当方は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます）がないことを保証するものではありません。
              </li>
              <li>
                当方は、本サービスに起因して利用者に生じたあらゆる損害について一切の責任を負いません。ただし、本サービスに関する当方と利用者との間の契約が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
              </li>
              <li>
                利用者が本サービスに登録したデータ（企業情報、応募状況、スケジュール等）については、利用者自身の責任において適切にバックアップを行うものとします。当方は、データの消失、破損等について一切の責任を負いません。
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第8条（サービス内容の変更等）
            </h2>
            <p>
              当方は、利用者に通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによって利用者に生じた損害について一切の責任を負いません。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第9条（利用規約の変更）
            </h2>
            <p>
              当方は、必要と判断した場合には、利用者に通知することなくいつでも本規約を変更することができるものとします。変更後の本規約は、本サービス上に掲載された時点から効力を生じるものとします。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              第10条（準拠法・裁判管轄）
            </h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
              <li>
                本サービスに関して紛争が生じた場合には、当方の所在地を管轄する裁判所を専属的合意管轄とします。
              </li>
            </ol>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">以上</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/login"
            className="text-indigo-600 hover:text-indigo-700 font-medium"
          >
            ← ログインページに戻る
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
